export default class MojangUtils {

	public static async checkOriginals(nick: string) {
		return await fetch("https://api.minetools.eu/uuid/" + nick)
			.then((res: Response) => res.json())
			.then((result: any) => {
				return result.status === "OK";
			});
	}

}
